interface InputErrorMessageProps {
  message: string | null;
  link?: string;
}

const InputErrorMessage = ({ message, link }: InputErrorMessageProps) => {
  const cursorPointer = link ? 'cursor-pointer' : '';

  if (message === null) return null;

  if (link) {
    return (
      <span className={`text-red-500 text-sm ${cursorPointer}`}>
        <a href={`/${link}`}>{message}</a>
      </span>
    );
  }

  return <span className="text-red-500 text-sm">{message}</span>;
};

export default InputErrorMessage;
